import { render } from "./Header.vue?vue&type=template&id=a06cb944&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=a06cb944&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\Erp Con api propia\\ERP CON MI-API\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a06cb944"]])

export default __exports__